import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "sales-report-new" };
import SalesReportNewHeader from '@/features/SalesReportNew/components/Header/SalesReportNewHeader.vue';
import SalesReportNewTable from '@/features/SalesReportNew/components/Table/SalesReportNewTable.vue';
import ModalProcessProgress from '@/features/SalesReportNew/components/Modals/ModalProcessProgress.vue';
import ModalExportSuccess from '@/features/SalesReportNew/components/Modals/ModalExportSuccess.vue';
import ModalExportError from '@/features/SalesReportNew/components/Modals/ModalExportError.vue';
import SalesReportNewKpis from '@/features/SalesReportNew/components/Kpis/SalesReportNewKpis.vue';
import SalesReportNewGraphic from '@/features/SalesReportNew/components/Graphic/SalesReportNewGraphic.vue';
// utilities
import { useMixpanelConfig } from '@/utilities/mixpanel';
// libs
import { onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SalesReportNew',
    setup(__props) {
        onMounted(() => {
            useMixpanelConfig('view_oto_sales_report_new');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SalesReportNewHeader),
                _createVNode(SalesReportNewKpis),
                _createVNode(SalesReportNewGraphic),
                _createVNode(SalesReportNewTable),
                _createVNode(ModalProcessProgress),
                _createVNode(ModalExportSuccess),
                _createVNode(ModalExportError)
            ]));
        };
    }
});
